//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

(function () {
  const curalate = angular.module('curalate');
  const contentSourceTypes = {
    HASHTAG: 'hashtag',
    USER: 'user',
    BUSINESS_USER: 'business-user',
    MENTION: 'mention',
    LINK: 'link',
    UPLOAD: 'upload',
    CLICK_HANDLER_SOURCES: ['hashtag', 'user', 'business-user'],
    TRACKED_SOURCE: ['hashtag', 'user', 'business-user', 'mention'],
    ALL: ['hashtag', 'user', 'business-user', 'mention', 'upload'],

    sourceTypeToCollectionEntityType(sourceType) {
      switch (sourceType) {
        case 'business-user':
          return 'InstagramBusinessUser';
        case 'user':
          return 'InstagramUser';
        case 'hashtag':
          return 'InstagramTag';
        default:
          return 'Unknown';
      }
    },
  };

  const contentSourceTypeTitles = {};
  contentSourceTypeTitles[contentSourceTypes.HASHTAG] = 'Hashtags';
  contentSourceTypeTitles[contentSourceTypes.USER] = 'Users';
  contentSourceTypeTitles[contentSourceTypes.BUSINESS_USER] = 'Users';
  contentSourceTypeTitles[contentSourceTypes.MENTION] = 'Account Mentions';

  const contentSearchStateTypes = {
    ANY: 'any',
    ALL: 'all',
  };
  const contentSearchSortTypes = {
    TIME: 'time',
    ENGAGEMENT: 'engagement',
    LIKES: 'likes',
    COMMENTS: 'comments',
    VISUAL_SCORE: 'visualScore',
    EMV: 'emv',
  };

  const contentTrackingConstants = {
    SOURCE_TRACKING_LAG_MS: 90000, // 1.5 * 60 * 1000 = 1.5 minutes
  };
  const contentTrackingStatus = {
    UNTRACKED: 'untracked',
    TRACKING: 'tracking',
    TRACKING_SUCCESS: 'tracking_success',
    TRACKED: 'tracked',
    UNKNOWN: 'unknown',
  };
  const contentDetailApps = {
    CONTENT_COLLECTIONS: 'content-collections',
    EXPLORE: 'explore',
  };

  curalate.constant('ContentTrackingConstants', contentTrackingConstants);
  curalate.constant('ContentTrackingStatus', contentTrackingStatus);
  curalate.constant('ContentSourceTypes', contentSourceTypes);
  curalate.constant('ContentSourceTypeTitles', contentSourceTypeTitles);
  curalate.constant('ContentSearchTypes', {
    STATE: contentSearchStateTypes,
    SORT: contentSearchSortTypes,
  });

  curalate.constant('AutocompleteTypes', {
    INSTAGRAM_USERS_AND_HASHTAGS: 'InstagramUsersAndHashtags',
    LABELS: 'Labels',
    VISUAL_TAGS: 'VisualTags',
  });

  curalate.constant('ContentFilterTypes', {
    HASHTAG: 'hashtag',
    USERNAME: 'username',
    SEMANTIC_TAG: 'semanticTag',
  });

  curalate.constant('ContentDetailApps', contentDetailApps);

  curalate.factory('ContentSourceService', () => ({
    ContentSourceTypes: contentSourceTypes,
    getSafeContentSourceType(rawSourceType) {
      if (rawSourceType === contentSourceTypes.BUSINESS_USER) {
        return contentSourceTypes.BUSINESS_USER;
      }
      // Remove capitalization and pluralization
      const cleanSourceType = rawSourceType.toUpperCase().replace(/S$/, '');
      return contentSourceTypes[cleanSourceType];
    },
  }));
})();
